import React, { useContext } from 'react'

import { DEFAULT_AVATAR_IMG } from 'interfaces/constants'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'

import Edit from '../icons/Edit'
import {
  StyledAvatar,
  StyledInputIcon,
  StyledInputText,
  StyledInputWrapper,
  StyledWrapper,
} from './index.styled'

export type Props = {
  onClick?: () => void
}

const InputPost = ({ ...rest }: Props) => {
  const { formatMessage: f } = useIntl()
  const { state } = useContext(AppContext)
  const { isLoggedIn, userInfo } = state

  return (
    <StyledWrapper {...rest} data-has-border={isLoggedIn}>
      {isLoggedIn && (
        <StyledAvatar
          className={`avatar-wrapper `}
          avatar={userInfo?.id ? userInfo.avatar : DEFAULT_AVATAR_IMG}
          username={userInfo?.name || userInfo?.username}
        />
      )}

      <StyledInputWrapper data-show-full={!isLoggedIn}>
        <StyledInputIcon>
          <Edit />
        </StyledInputIcon>
        <StyledInputText>
          {f({
            id: 'askDoctor.inputPost.text',
            defaultMessage: 'Đặt câu hỏi',
          })}
        </StyledInputText>
      </StyledInputWrapper>
    </StyledWrapper>
  )
}

export { InputPost }
